var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-header',{attrs:{"icon":"fa-chart-line","title":"Enrollment"}}),_c('card-body'),_c('card-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }